import { Link, Stack } from "expo-router";
import { Page } from "~/components/layout/Page";
import { BaseText, Title } from "~/components/layout/text";
import { useDismiss } from "~/providers/DismissProvider";

export default function NotFoundScreen() {
    const { dismiss_to } = useDismiss();

    return (
        <>
            <Stack.Screen options={{ title: "Oops!" }} />
            <Page gradient spacer>
                <Title>This screen doesn&apos;t exist.</Title>
                <Link href={dismiss_to}>
                    <BaseText colour="link">Go back</BaseText>
                </Link>
            </Page>
        </>
    );
}
